// extracted by mini-css-extract-plugin
export default {"result-button-content":"styles_result-button-content__VO+m5","result-button":"styles_result-button__6SDoA","download-button-icon":"styles_download-button-icon__S25Qs"};